// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.231",
  "gitHash": "ca77a31037b5812f62519f6f890a690878c17e0f",
  "versionWithHash": "5.5.231-ca77a31037b5812f62519f6f890a690878c17e0f"
};
